import { render, staticRenderFns } from "./weixinLogin.vue?vue&type=template&id=597c451a&scoped=true&"
import script from "./weixinLogin.vue?vue&type=script&lang=js&"
export * from "./weixinLogin.vue?vue&type=script&lang=js&"
import style0 from "./weixinLogin.vue?vue&type=style&index=0&id=597c451a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c451a",
  null
  
)

export default component.exports